function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 7.44c0-.86.55-1.624 1.368-1.896l9.367-3.122a4 4 0 012.53 0l9.367 3.122A1.998 1.998 0 0128 7.44V15c0 10.562-9.296 14.152-11.524 14.86-.313.1-.639.1-.952 0C13.296 29.152 4 25.562 4 15V7.44z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26 8.523A1.5 1.5 0 0024.974 7.1l-7.987-2.663A.75.75 0 0016 5.15v10.85h9.25a.75.75 0 00.75-.75V8.524z",
  fill: "url(#confidentiality_svg__paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.968 16v10.883c0 .508-.495.867-.965.673l-.14-.058a17.344 17.344 0 01-3.694-2.098c-2.32-1.739-4.582-4.43-5.093-8.602A.72.72 0 016.802 16h9.166z",
  fill: "url(#confidentiality_svg__paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "confidentiality_svg__paint0_linear",
  x1: 17.875,
  y1: 4.398,
  x2: 25.778,
  y2: 5.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "confidentiality_svg__paint1_linear",
  x1: 7.926,
  y1: 16,
  x2: 15.755,
  y2: 17.526,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgConfidentiality = function SvgConfidentiality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgConfidentiality;